import { Injectable, WritableSignal, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StoreService {
    isDataLoading = signal<boolean>(true);
    amountRequiredToMeetStake: WritableSignal<string> = signal<string>('0.0');
    isLoading: WritableSignal<boolean> = signal<boolean>(true);
    adaInteraction: WritableSignal<boolean> = signal<boolean>(false);
    arcDepositBlockStatus = signal<boolean>(false);
    errorCode = signal<number>(0);
    continueDeposit = signal<boolean>(false);

    setcontinueDeposit(val: boolean) {
        this.continueDeposit.set(val);
    }
    getcontinueDeposit() {
        return this.continueDeposit;
    }
    setErrorCode(code: number) {
        this.errorCode.set(code);
    }
    getErrorCode() {
        return this.errorCode;
    }
    setLoadingInfo(value: boolean) {
        this.isLoading.set(value);
    }
    getLoadingInfo() {
        return this.isLoading;
    }

    setAdaInteractionMessage(data: boolean) {
        this.adaInteraction.set(data);
    }
    getAdaInteractionMessage() {
        return this.adaInteraction;
    }
    setRequiredAmount(val: string) {
        this.amountRequiredToMeetStake.set(val);
    }
    getRequiredAmountToMeetStake() {
        return this.amountRequiredToMeetStake();
    }
    setArcDepositBlockStatus(val: any) {
        this.arcDepositBlockStatus.set(val);
    }
    getArcDepositBlockStatus() {
        return this.arcDepositBlockStatus();
    }
}
